import {
  RESET_CUSTOMER_DASHBOARD_ISFETCHING,
  CUSTOMER_DASHBOARD_OBJECT_REQUESTING,
  GET_CUSTOMER_DASHBOARD_SUCCESS,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_FOR_DASHBOARD_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  virtualCart: null,
  isObjectFetching: false,
  total: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_DASHBOARD_ISFETCHING: {
      return {
        ...state,
        isObjectFetching: false
      };
    }
    case CUSTOMER_DASHBOARD_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }

    case GET_CUSTOMER_DASHBOARD_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        isObjectFetching: false
      };

    case GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_FOR_DASHBOARD_SUCCESS: {
      const virtualCart = { ...state.virtualCart };

      virtualCart[action.clubMemberShipmentId] = action.payload;

      return {
        ...state,
        virtualCart,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
